module.exports = __webpack_public_path__ + "img/haifeng-big.b5c6b204.jpg";